// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"762":"bundled-workspace","938":"bundled-404","956":"bundled-sign-in"}[chunkId] + "." + {"762":"79009b48","938":"c9a48d0a","956":"cf24bb1c"}[chunkId] + ".js";
};